import React from 'react'
import PropTypes from 'prop-types';
import Wadium from './Wadium';

function Index(
    {
        expanded,
    }) {
    return expanded && <Wadium/>
}

Index.propTypes = {
    classes: PropTypes.any,
}

export default Index;